import { Pipe, PipeTransform } from '@angular/core';
import { MediaPlayerFile } from '../../../interfaces/media-player-store.interface';

@Pipe({
  name: 'fileTypeIcon',
  standalone: true,
})
export class FileTypeIconPipe implements PipeTransform {
  public transform(file: MediaPlayerFile | null | undefined): string {
    if (!file?.contentType) {
      return 'assets/img/icons/unknown.svg';
    }

    const lastSlashIndex: number = file.contentType.lastIndexOf('/');
    const fileType: string = lastSlashIndex >= 0 ? file.contentType.substring(lastSlashIndex + 1) : file.contentType;

    return `assets/img/icons/${fileType}.svg`;
  }
}
